/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1CourseCourseidLanguagesAvailable200,
  GetApiV1CourseCourseidLanguagesAvailable401,
  GetApiV1CourseCourseidLanguagesAvailable404,
  GetApiV1CourseCourseidLanguagesAvailable500,
  GetApiV1CourseCourseidLanguagesAvailablePathParams,
  GetApiV1CourseCourseidLanguagesAvailableQueryResponse,
} from "../../types/courseLangsController/GetApiV1CourseCourseidLanguagesAvailable.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

export const getApiV1CourseCourseidLanguagesAvailablePathParamsSchema =
  z.object({
    courseId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1CourseCourseidLanguagesAvailablePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1CourseCourseidLanguagesAvailable200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1CourseCourseidLanguagesAvailable200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1CourseCourseidLanguagesAvailable401Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguagesAvailable401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1CourseCourseidLanguagesAvailable404Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguagesAvailable404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1CourseCourseidLanguagesAvailable500Schema =
  z.any() as unknown as ToZod<GetApiV1CourseCourseidLanguagesAvailable500>;

export const getApiV1CourseCourseidLanguagesAvailableQueryResponseSchema =
  z.lazy(
    () => getApiV1CourseCourseidLanguagesAvailable200Schema,
  ) as unknown as ToZod<GetApiV1CourseCourseidLanguagesAvailableQueryResponse>;
